import { Injectable } from '@angular/core';
import { } from '@angular/router';
import { ElasticSearchService } from './elastic-search.service';
import { NotificationService } from '.';
import { Http } from '@angular/http';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { environment } from '../../environments/environment';
import { AngularFirestore } from 'angularfire2/firestore';
import { WeeklyPostsService } from './weeklyPosts.service';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PostService {
  hashtags =
    [{
      value: "#şikayetimvar",
      name: "ŞikayetimVar",
      disabled: false
    },
    {
      value: "#bunuçoksevdim",
      name: "BunuÇokSevdim",
      disabled: false
    },
    {
      value: "#markamaönerim",
      name: "MarkamaÖnerim",
      disabled: false
    },
    {
      value: "#benimtavsiyem",
      name: "BenimTavsiyem",
      disabled: false
    }];
  ipAddres: any;
  subscribtion = new Subscription();
  postObs: Observable<any[]>;
  postsubsribe = new Subscription();
  public posts: any;
  posts1 = new BehaviorSubject<any[]>([]);
  constructor(private elasticSearchService: ElasticSearchService,
    private notificationService: NotificationService,
    private weeklypsotservice: WeeklyPostsService,
    private _http: Http,
    private afs: AngularFirestore,
    private afm: AngularFireDatabase) {
    this.getIpAdress();
  }

  getAverageRate(postDetails) {
    try {
      let total = postDetails.rating.criterias.reduce((a, b) => {
        return a + b.point
      }, 0);
      let avg = total / (postDetails.rating.criterias.filter(criteria => criteria.point != 0).length || 1)
      return avg
    } catch (e) {
      return 0;
    }
  }
  rateUpdate(postDetails) {
    console.log(postDetails)
    this.afs.collection(postDetails.rating.type + 's').ref.where('uniqueName', '==', postDetails.rating.uniqueName).get().then(brandID => {
      this.afs.collection(postDetails.rating.type + 's').doc(brandID.docs[0].id).collection('userRates').doc(postDetails.userId).set({
        criteria: postDetails.rating.criterias,
        modifyDate: Date.now(),
        rate: postDetails.rating.userRate
      });
      if (postDetails.rating.type === 'brand' && postDetails.rating.isRateable) {
        this.afs.collection('brands').doc(brandID.docs[0].id).collection('categories').ref.where('name', '==', 'Genel').get().then(snap => {

          if (snap.empty) {
            this.afs.collection('brands').doc(brandID.docs[0].id).collection('categories').add({ name: 'Genel' })

          }
        })
      }

    })
    if (postDetails.rating.type === 'product') {
      this.afs.collection('brands').ref.where('uniqueName', '==', postDetails.rating.brand).get().then(brandId => {
        this.afs.collection('brands').doc(brandId.docs[0].id).collection('categories').ref.where('name', '==', postDetails.rating.category).get().then(categoryId => {
          if (categoryId)
            this.afs.collection('brands').doc(brandId.docs[0].id).collection('categories').doc(categoryId.docs[0].id).update({ name: postDetails.rating.category })
          else {
            this.afs.collection('brands').doc(brandId.docs[0].id).collection('categories').add({ name: postDetails.rating.category });

          }
        })
      })
    }
  }
  async sharePost(postDetails) {


    let offset = await this.afm.list('.info/serverTimeOffset').$ref.once('value');
    let dateNow = Date.now() + offset.val();
    let text = postDetails.text;
    let html = text;
    const hashtags = text.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) ? postDetails.text.match(/#[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) : [];
    const products = postDetails.text.match(/@[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) ? postDetails.text.match(/@[A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ]+/ig) : [];
    this.rateUpdate(postDetails);

    // if (postDetails.rating.userRate < 5 && postDetails.text.toLowerCase().indexOf("#şikayetimvar") == -1) {
    //   postInPath.push("hashtag/şikayetimvar/timeline/" + postDetails.postKey)
    // }
    // else if (postDetails.rating.userRate >= 8 && postDetails.rating.userRate < 9 && postDetails.text.toLowerCase().indexOf("#bunuçoksevdim") == -1) {
    //   postInPath.push("categories/" + this.changeTextCategory(postDetails.rating.category) + '/hashtags/bunuçoksevdim/' + postDetails.postKey)
    //   postInPath.push("hashtag/bunuçoksevdim/timeline/" + postDetails.postKey)
    // } else if (postDetails.rating.userRate >= 9 && postDetails.text.toLowerCase().indexOf("#benimtavsiyem") == -1) {
    //   postInPath.push("hashtag/benimtavsiyem/timeline/" + postDetails.postKey)
    //   postInPath.push("categories/" + this.changeTextCategory(postDetails.rating.category) + '/hashtags/benimtavsiyem/' + postDetails.postKey)
    // }
    // postInPath.push("categories/" + this.changeTextCategory(postDetails.rating.category) + '/timeline/' + postDetails.postKey)

    this.afs.collection('posts').add({
      order: -1 * dateNow,
      modifyDate: dateNow,
      settings: postDetails.postSettings,
      valueOf: 0,
      valueOf_ModifyDate: -1 * parseInt(dateNow),
      innerText: postDetails.text,
      files: postDetails.files || [],
      author: {
        firstname: postDetails.user.firstname,
        lastname: postDetails.user.lastname,
        username: postDetails.user.username,
        profileImage: postDetails.user.profileImage,
        userKey: postDetails.userId,
        level: postDetails.user.level || 0
      },
      rating: postDetails.rating,
      ipAddres: this.ipAddres,
      user: postDetails.userId
    }).then((dataKey) => {


      this.elasticSearchService.getProducts(products, (hits: any[]) => {
        hits.filter(data => {
          if (data.type == "user") {
            // let message = {
            //   body: "<span><strong>" + postDetails.user.firstname + postDetails.user.lastname + "</strong> seni bir gönderide etiketledi.</span>",
            //   innerBody: postDetails.user.firstname + postDetails.user.lastname + " seni bir gönderide etiketledi.",
            //   click_action: environment.domainName + "post/" + postDetails.postKey,
            //   action: "post/" + postDetails.postKey,
            //   image: postDetails.user.profileImage,
            //   isUnseen: true,
            //   modifyDate: Date.now(),
            //   title: "Etiket"
            // }
          }
          else {

            if (data.type == "product" || (data.type == "brand" && data.isRateable)) {
              this.getBadgePoint(data.category, postDetails);
            }
          }
          if (data.type == "user" || "brand" || "product") {
            html = html.replace("@" + data.uniqueName, '<a href="' + data.uniqueName + '">@' + data.uniqueName + '</a>');
          } else {
            html = html.replace("@" + data.uniqueName, '<a href="' + data.type + '/' + data.uniqueName + '">@' + data.uniqueName + '</a>');
          }

          this.postCount(postDetails.userId, postDetails.rating);
          hashtags.forEach(hashtag => {
            postDetails.modifyDate = dateNow;
            hashtag = hashtag.substring(1);
            html = html.replace("#" + hashtag, '<a href="hashtag/' + hashtag.toLowerCase() + '">#' + hashtag + '</a>');

            this.afs.collection('posts').doc(dataKey.id).update({ ['tag-' + hashtag.toLowerCase()]: true, text: html }).then(() => {

              this.weeklypsotservice.weeklyPosts(hashtag, postDetails);
            })
          });
        })



        // this.afs.collection('users').doc(dataKey.id).update({ lastPostDate: dateNow });

      });
    })


    // });

  }

  async getBadgePoint(categoryName: string, postDetails) {

  }
  changeTextCategory(string) {
    return string
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/-/g, '')
      .replace(/\./g, '_')
      .replace(/\'/g, '')
      .replace(/\s/g, '_').toLowerCase();
  }

  getIpAdress() {
    this.subscribtion = this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddres = data.json() }).subscribe();
  }
  hashtagPosts(value, order) {
    this.subscribtion.unsubscribe();
    this.subscribtion = null;
    this.posts1.next([]);

    this.subscribtion = this.afs.collection('posts',
      ref => ref.where('tag-' + value, '==', true)
        .orderBy(order).limit(17)
    ).snapshotChanges().pipe(map(actions => {
      return actions.map(a => {
        return {
          id: a.payload.doc.id,
          ...a.payload.doc.data()
        }
      })
    })).subscribe(data => {
      this.posts1.next(data);
    });
  }
  getposts() {
    return this.posts1.asObservable();
  }

  hashtagPosts2(value) {
    return this.afs.collection('posts',
      ref => ref.where('tag-' + value, '==', true)
        .orderBy('valueOf_ModifyDate').limit(17)
    ).snapshotChanges().pipe(map(actions => {
      return actions.map(a => {
        return {
          id: a.payload.doc.id,
          ...a.payload.doc.data()
        }
      })
    }));
  }

  postCount(userId, rating) {

    this.afs.collection('users').doc(userId).ref.get().then((data) => {
      this.afs.collection('users').doc(userId).update({
        myPosts: data.data().myPosts ? data.data().myPosts + 1 : 1
      })
        .then(() => {


          if (rating.type === 'brand') {
            this.afs.collection('brands').ref.where('uniqueName', '==', rating.uniqueName).get().then((data => {
              if (data) {
                this.afs.collection('brands').doc(data.docs[0].id).update({
                  myPosts: data.docs[0].data().myPosts ? data.docs[0].data().myPosts + 1 : 1
                })
              }

            }))
          }
          else if (rating.type === 'product') {
            this.afs.collection('products').ref.where('uniqueName', '==', rating.uniqueName).get().then((data => {
              if (data) {
                this.afs.collection('products').doc(data.docs[0].id).update({
                  myPosts: data.docs[0].data().myPosts ? data.docs[0].data().myPosts + 1 : 1
                })
              }

            }))

          }

        })
    })

  }

  ngOnDestroy() {
    this.subscribtion.unsubscribe();

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/post.service.ts